import { Banner, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import CollateralShareDonutChart from './CollateralShareDonutChart';
import GroupsTable from './GroupsTable';
import OverviewKpis from './OverviewKpis';

export default function CollateralPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  return (
    <Page title="Collateral">
      <Banner>
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Sky Protocol Collateral</Heading>
          <br />
          Explore the collateral that&apos;s backing all the USDS and DAI
          stablecoins in existence. This page offers an overview of the relevant
          metrics, as well as a granular breakdown of both the collateral and
          the debt that the Sky Protocol manages.
        </Box>
      </Banner>
      <OverviewKpis daysAgo={daysAgo} />
      <GroupsTable daysAgo={daysAgo} />
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <Flex flexBasis="50%" flexDirection="column">
          <Flex flexBasis="100%" flexDirection="column" alignItems="center">
            <Heading size="3">Debt Distribution</Heading>
            <CollateralShareDonutChart type="debt" />
          </Flex>
        </Flex>

        <Flex flexBasis="50%" flexDirection="column">
          <Flex flexBasis="100%" flexDirection="column" alignItems="center">
            <Heading size="3">Collateral Distribution</Heading>
            <CollateralShareDonutChart type="collateral" />
          </Flex>
        </Flex>
      </Flex>
    </Page>
  );
}
